<template>
  <div class="tabs_content">
    <modal ref="devicemetadatamodalref">
      <div slot="title">{{ metadata && $_date_formatFull(metadata.timestamp_created, false) }}</div>
      <div slot="body">
        <pre class="device-metadata-data-detail">
{{ metadata && metadata.data | json }}
        </pre>
      </div>
    </modal>
    <section>
      <div class="status">
        <h2 v-translate>Metadata zařízení</h2>
      </div>
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="device-metadata-list">
          <table class="vypis">
            <thead>
              <tr v-if="entities.length > 0">
                <th><span v-translate>Vytvořeno</span></th>
                <th><span v-translate>Data</span></th>
              </tr>
            </thead>
            <tbody>
              <device-metadata-row
                  v-for="entity in entities"
                  :key="entity.id"
                  :entity="entity"
                  @showModal="showModal(arguments[0])"
              />
              <tr v-if="entities.length === 0">
                <td colspan="2" v-translate>Nebyla nalezena žádná metadata.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :offset="offset"
          :limit="limit"
          :total-count="totalCount"
          table-id="device-metadata-list"
          @limit="onLimit"
          @offset="onOffset"
      />
    </section>
  </div>
</template>

<script>
import ListActionLine from "@/components/common/ListActionLine"
import DeviceMetadataRow from "./DeviceMetadataRow.vue"
import message from "@/components/mixins/message"

export default {
    name: "DeviceMetadata",
    components: { ListActionLine, DeviceMetadataRow },
    mixins: [message],
    props: {
        entity: Object,
    },
    data() {
        return {
            entities: [],
            totalCount: 0,
            limit: 20,
            offset: 0,
            metadata: null,
        }
    },
    created(DeviceService) {
        this.deviceService = DeviceService
        this.loadMetadata()
    },
    filters: {
        json(value) {
          return JSON.stringify(value, null, 2)
        }
    },
    methods: {
        loadMetadata() {
            this.setLoadingMessage()
            this.deviceService.getDeviceMetadata(this.entity.id, {
                limit: this.limit,
                offset: this.offset,
            }).then((data) => {
                this.emptyMessage()
                this.entities = data.device_metadata
                this.totalCount = Number(data.totalCount)
            }).catch((error) => {
                this.setErrorMessage(error.error_message)
            })
        },
        onLimit(limit) {
            this.limit = limit
            this.offset = 0
            this.loadMetadata()
        },
        onOffset(offset) {
            this.offset = offset
            this.loadMetadata()
        },
      showModal(entity) {
        this.metadata = entity
        this.$refs.devicemetadatamodalref.showModal(true)
      }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/DeviceMetadata.vue